module.exports = __webpack_public_path__ + "img/right.8a3b9b45.jpg";